<script>
import mineSelect from './mineSelect';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number, Object],
            default: null,
        },
    },
    name: "mineSelect",
    data() {
        return {
            isActive: this.show,
            isTapThis: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        this.onSelectTap();
        window.addEventListener('click', this.handleBodyClick);
    },
    destroyed() {
        window.removeEventListener('click', this.handleBodyClick);
    },
    watch: {
        show: {
            handler: function (value) { 
                if (typeof value === 'boolean') this.isActive = value;
            },
            immediate: true
        }
    },
    methods: {
        // body点击监听
        handleBodyClick() { 
            this.isActive = false;
        },
        // 监听当前页面所有下拉点击
        onSelectTap() { 
            mineSelect.$on('tap', () => {
                // 点击的不是当前组件
                if (!this.isTapThis) { 
                    // 隐藏下拉
                    this.isActive = false;
                } else {
                    // 是当前组件
                    this.isTapThis = false;
                }
            })
        },
        // 下拉内部元素点击
        tapDom() { 
            this.isTapThis = true;
            mineSelect.$emit('tap');
        },
        // 点击value
        tapValue() { 
            this.isActive = !this.isActive;
            this.tapDom();
        },
        // 取消按钮点击
        cancel() {
            this.isActive = false;
        },
        // 确定按钮点击
        // confirm() {
        //     this.isActive = false;
        //     this.$emit('input', this.value);
        // },
    },
};
</script>

<template>
    <div class="mine_select" :class="{active: isActive}">
        <div class="value" @click.stop="tapValue">
            <slot name="value" v-if="value"></slot>
            <p class="placeholder" v-else>请选择</p>
        </div>
        <div class="options only_pc"><slot></slot></div>
        <div class="options only_mobile">
            <div class="in">
                <div class="top flex justify_between align_center" @click.stop="tapDom">
                    <div class="btn_cancel" @click="cancel">取消</div>
                    <!-- <div class="btn_confirm" @click="confirm">确定</div> -->
                </div>
                <div class="list"><slot></slot></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.mine_select{
    position: relative;
    font-size: .16rem;
    user-select: none;
    width: 100%;
    @media screen and (max-width: 750px) {
        font-size: .25rem;
    }
    &.active{
        z-index: 1;
        .value{
            border-radius: .05rem .05rem 0 0;
            z-index: 1;
            &::after{
                transform: translate(-50%, -25%) rotate(-135deg);
            }
        }
        .options{
            display: block;
        }
    }
    .value{
        width: 100%;
        height: .4rem;
        border: 1px solid #333;
        border-radius: .05rem;
        padding: 0 .4rem 0 .1rem;
        // display: flex;
        // align-items: center;
        line-height: .4rem;
        cursor: pointer;
        position: relative;
        // 溢出隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        @media screen and (max-width: 750px) {
            height: .6rem;
            line-height: .6rem;
            padding: 0 .2rem;
        }
        .placeholder{
            color: #b2b2b2;
        }
        // 箭头
        &::after{
            content: "";
            width: .1rem;
            height: .1rem;
            border-right: 1px solid #333;
            border-bottom: 1px solid #333;
            position: absolute;
            right: .08rem;
            top: 50%;
            transform: translate(-50%, -75%) rotate(45deg);
        }
    }
    .options{
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        border: 1px solid #333;
        border-top: none;
        border-radius: 0 0 .05rem .05rem;
        background: #fff;
        display: none;
        max-height: 2.5rem;
        overflow-y: auto;
        @media screen and (max-width: 750px) {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            max-height: none;
            background: rgba($color: #000000, $alpha: .7);
            z-index: 9;
            border: none;
            border-radius: 0;
            overflow-y: hidden;
            .in{
                border-radius: .3rem .3rem 0 0;
                box-shadow: 0 -.05rem .1rem rgba(0, 0, 0, .1);
                padding-top: .3rem;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                background: #efefef;
                .top{
                    padding: 0 .3rem;
                    margin-bottom: .2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .btn_cancel, .btn_confirm{
                        font-size: .25rem;
                    }
                    .btn_confirm{
                        color: #007aff;
                    }
                }
                .list{
                    overflow-y: auto;
                    height: 5rem;
                    padding-bottom: .2rem;
                }
            }
        }
        // .option{
        //     padding: 0 .1rem;
        //     height: .35rem;
        //     cursor: pointer;
        //     line-height: .35rem;
        //     cursor: pointer;
        //     &.active,
        //     &:hover{
        //         background: #f1f1f1;
        //     }
        // }
    }
}
</style>